import React from 'react';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import {styled} from "@mui/styles";

import {greyishBlue50} from "assets/jss/main";

function FeedTypeCreationList(props) {
    const StyledLink = styled(Link)({
        color: 'black',
        textDecoration: 'none',
        padding: '12px 16px',
        '&:hover': {
            backgroundColor: greyishBlue50
        }
    });

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <StyledLink to="csv-local/create">
                <FormattedMessage id={"feed.list.action.create.CSVLocalFeed"}/>
            </StyledLink>
            <StyledLink to="csv-remote/create">
                <FormattedMessage id={"feed.list.action.create.CSVRemoteFeed"}/>
            </StyledLink>
            <StyledLink to="xml-local/create">
                <FormattedMessage id={"feed.list.action.create.XMLLocalFeed"}/>
            </StyledLink>
            <StyledLink to="xml-remote/create">
                <FormattedMessage id={"feed.list.action.create.XMLRemoteFeed"}/>
            </StyledLink>
            <StyledLink to="json-local/create">
                <FormattedMessage id={"feed.list.action.create.JSONLocalFeed"}/>
            </StyledLink>
            <StyledLink to="json-remote/create">
                <FormattedMessage id={"feed.list.action.create.JSONRemoteFeed"}/>
            </StyledLink>
            <StyledLink to="csv-ftp/create">
                <FormattedMessage id={"feed.list.action.create.ftpFeed"}/>
            </StyledLink>
            <StyledLink to="xml-ftp/create">
                <FormattedMessage id={"feed.list.action.create.xmlFtpFeed"}/>
            </StyledLink>
            <StyledLink to="json-ftp/create">
                <FormattedMessage id={"feed.list.action.create.JSONFtpFeed"}/>
            </StyledLink>
            <StyledLink to="google-sheets-remote/create">
                <FormattedMessage id={"feed.list.action.create.GoogleSpreadsheetFeed"}/>
            </StyledLink>
            <StyledLink to="api/create">
                <FormattedMessage id={"feed.list.action.create.apiFeed"}/>
            </StyledLink>
            <StyledLink to="enrichment-database/create">
                <FormattedMessage id={"feed.list.action.create.enrichment-db"}/>
            </StyledLink>
        </div>
    );
}

export default FeedTypeCreationList;
